import { useQuery } from "@apollo/client";
import { useState, createContext, useContext, useEffect, useMemo } from "react";
import { GET_ME, GET_TEAMS } from "services/apollo/Queries";
import { useAdmin } from "features/admin/AdminContext";
import logger from "Utils/logger";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const { user, setUser, all_users, setAll_users, fetchUsers } = useAdmin();
    const [loader, setLoader] = useState(true);
    // const [all_users, setAll_users] = useState([]);
    // const [user, setUser] = useState(null);
    const [activeUser, setActiveUser] = useState(null);
    const [currentTab, setCurrentTab] = useState('Member'); // Recipient, Guest, Member
    const [filterState, setFilterState] = useState(''); // 0, 1, '', 'Admin', 'Member'
    const [searchString, setSearchString] = useState('');
    const [teams, setTeams] = useState([]);


    // const [fetchUsers] = useLazyQuery(GET_ALL_USERS, {
    //     fetchPolicy: 'no-cache',
    //     onCompleted: (data) => {
    //         setLoader(false);
    //         setAll_users(data?.users?.filter(v => v.role !== 'Public User') || []);
    //     }
    // });

    useQuery(GET_ME, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
            setUser(data.me);
        }
    });

    useQuery(GET_TEAMS, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
            logger.log(36, data);

            if (data?.teams) {
                let team = [];
                for (const iterator of data.teams) {
                    team.push({ value: iterator.team_id, label: iterator.team_title });
                }
                setTeams(team)
            }
        }
    });

    useEffect(() => {
        if (user?.company_id) {
            // setLoader(true);
            fetchUsers({ variables: { company_id: user.company_id } });
            setLoader(false);
        }
    }, [user, fetchUsers]);

    const tabCounters = useMemo(() => ({
        Member: all_users.filter(u => u.role === 'Member' || u.role === 'Admin').length,
        Guest: all_users.filter(u => u.role === 'Guest').length,
        Recipient: all_users.filter(u => u.role === 'Recipient').length,
    }), [all_users]);

    const filteredUsers = useMemo(() => {
        let users = all_users;

        // Filter by currentTab
        if (currentTab === 'Member') {
            users = users.filter(u => u.role === 'Member' || u.role === 'Admin');
        } else {
            users = users.filter(u => u.role === currentTab);
        }

        // Filter by filterState
        if (filterState !== '') {
            if (filterState === 'Admin' || filterState === 'Member') {
                users = users.filter(u => u.role === filterState);
            } else if (filterState === 0 || filterState === 1) {
                users = users.filter(u => u.is_active === filterState);
            }
        }

        // Filter by search string
        if (searchString) {
            const lowercasedSearch = searchString.toLowerCase();
            users = users.filter(u =>
                `${u.firstname} ${u.lastname}`.toLowerCase().includes(lowercasedSearch) ||
                u.email.toLowerCase().includes(lowercasedSearch)
            );
        }

        // Sort by full name (ascending)
        users = users.slice().sort((a, b) => {
            const nameA = `${a.firstname} ${a.lastname}`.toLowerCase();
            const nameB = `${b.firstname} ${b.lastname}`.toLowerCase();
            return nameA.localeCompare(nameB);
        });

        return users;
    }, [all_users, currentTab, filterState, searchString]);


    useEffect(() => {
        setFilterState('');
        setSearchString('');
    }, [currentTab]);

    // const [deleteErpUser] = useMutation(DELETE_USER_ERP_NEXT)

    // const handleDeleteErpUser = (userId) => {
    //     deleteErpUser({
    //         variables: {
    //             user_email: activeUser.email
    //         }
    //     });
    //     setAll_users(prev => prev.map(u => u.id === activeUser.id ? { ...u, erpNext: false, erpNextPass: null, erpNextRoles: [] } : u));
    //     toast.success('User module removed successfully');
    // }

    const contextValue = useMemo(() => ({
        loader,
        all_users,
        setAll_users,
        user,
        setUser,
        currentTab,
        setCurrentTab,
        current_users: filteredUsers,
        tabCounters,
        searchString,
        setSearchString,
        filterState,
        setFilterState,
        activeUser,
        setActiveUser,
        teams
        // handleDeleteErpUser,
    }), [loader, all_users, user, currentTab, filteredUsers, tabCounters, searchString, filterState, activeUser, setAll_users, setUser, teams]);

    return (
        <UserContext.Provider value={contextValue}>
            {children}
        </UserContext.Provider>
    );
};

export const useUsers = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error("useUsers must be used within a UserProvider");
    }
    return context;
};